module.exports = __webpack_public_path__ + "static/xbox-47dac245e3816cf683d130b290d7b316.png";